import React from 'react'
import { FooterButtons } from '@mobi/betslip/Components/Common/BetCard'
import type { Tabs, Ticket } from '@core/Areas/AccountActivity/types'
import { doesClientSupportShare } from '@core/Areas/ShareBet/helpers/doesClientSupportShare'
import { openShareOutgoing } from '@core/Areas/ShareBet/ShareBetOutgoing/helpers/emitter'

export const ShareBet: React.FC<{ ticket: Ticket; activeTab: Tabs }> = ({ ticket, activeTab }) => {
  if (!doesClientSupportShare()) return null

  const handleShareClick = () => {
    openShareOutgoing({
      contextType: 'ticket',
      share: { ticket, activeTab, ticketSequence: ticket.ticketSequence },
    })
  }

  return <FooterButtons.ShareButton onClick={handleShareClick} testId='share-bet-button' />
}
